/** 数字画像登录来源标识，与 PC 端 seo-main 保持一致 */
export const PORTRAIT_LOGIN_SOURCE = 'portraitSource';

/** 千里马小程序 - 标讯搜索列表 */
export const MINI_PROGRAM_TENDER_LIST_PATH = 'pages/buiness/buinessSearchByProduct';

/** 千里马小程序 - 标讯详情 */
export const MINI_PROGRAM_TENDER_DETAIL_PATH = 'pages/detail/marketDetail';
